import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, { creditId, reason }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      creditId,
      description: reason,
    }),
  };

  const userLoginInfoResult = await fetch(
    `${URI_TARIFF_PLAN}reversion/employee`,
    opts,
  );
  const jsonResult = await userLoginInfoResult.json();

  if (userLoginInfoResult.status >= 400) {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult;
};
